import { Navigate, useLocation } from "react-router-dom";
import { getRefreshToken } from "../../Variables/Common";

export function AuthValidation() {
  const refreshtokenData = getRefreshToken()
  const location = useLocation();

  if (!refreshtokenData) {
    return (
      <Navigate from='/home' to="/" />
    )
  }

  const currentPath = location.pathname;
  if (currentPath === '/') {
    return (
      <>
        <Navigate from='/' to="/home/" />
      </>
    )
  }

  return (<></>)
}

export function HomeNavigation(navigation, currentPath) {
  const refreshtokenData = getRefreshToken()

  if (!refreshtokenData && currentPath === '/home') {
    navigation("/")
  } else if (currentPath === '/' && (refreshtokenData !== null)) {
    navigation("/home")
  }
}